import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiService } from '../services/api';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaQuestion, setCaptchaQuestion] = useState('');
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [loading, setLoading] = useState(false);
  const [captchaLoading, setCaptchaLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');

  const loadCaptcha = async () => {
    setCaptchaLoading(true);
    setError('');
    try {
      const resp = await apiService.getPasswordResetCaptcha();
      setCaptchaToken(resp.data.captcha_token);
      setCaptchaQuestion(resp.data.question);
      setCaptchaAnswer('');
    } catch (e) {
      setError('Не удалось загрузить капчу. Попробуйте обновить страницу.');
    } finally {
      setCaptchaLoading(false);
    }
  };

  useEffect(() => {
    loadCaptcha().catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const resp = await apiService.requestPasswordReset({
        email: (email || '').trim().toLowerCase(),
        captcha_token: captchaToken,
        captcha_answer: captchaAnswer,
      });
      setDone(true);
      setMessage(resp.data?.message || 'Если email зарегистрирован, мы отправили письмо.');
    } catch (err) {
      const data = err.response?.data;
      const msg =
        data?.message ||
        data?.error ||
        (data?.captcha && (Array.isArray(data.captcha) ? data.captcha.join(' ') : String(data.captcha))) ||
        (data?.email && (Array.isArray(data.email) ? data.email.join(' ') : String(data.email))) ||
        data?.detail ||
        err.message ||
        'Не удалось отправить письмо.';
      setError(msg);
      await loadCaptcha();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Восстановление пароля</h2>

        {error && <div className="error-message">{error}</div>}
        {done && message && <div className="success-message">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Проверка:</label>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={{ color: '#1f2937' }}>
                {captchaLoading ? 'Загрузка…' : captchaQuestion}
              </span>
              <button
                type="button"
                onClick={loadCaptcha}
                disabled={captchaLoading || loading}
                style={{
                  padding: '8px 10px',
                  borderRadius: 8,
                  border: '1px solid #d1d5db',
                  background: '#fff',
                  cursor: 'pointer',
                }}
                title="Обновить капчу"
              >
                ↻
              </button>
            </div>
            <input
              type="text"
              value={captchaAnswer}
              onChange={(e) => setCaptchaAnswer(e.target.value)}
              placeholder="Ответ"
              required
              disabled={loading || captchaLoading}
              style={{ marginTop: 10 }}
            />
          </div>

          <button type="submit" disabled={loading || captchaLoading}>
            {loading ? 'Отправка…' : 'Отправить код'}
          </button>
        </form>

        <p className="auth-link">
          Уже есть код или ссылка? <Link to="/reset-password">Сменить пароль</Link>
        </p>
        <p className="auth-link">
          <Link to="/login">Вернуться ко входу</Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;

